import React, { RefObject, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
import { Grid } from '@mui/material';
import FlashLogTable from '../../../components/reports/table';
import TimeRange from '../../../components/time-range';
import { QueryParameterKeys } from '../../../globals/paramter';
import { AppState } from '../../../store';
import { getFlashLogExport, getFlashLogSummariesAction } from '../../../store/flash-log/actions';
import useStyles from './styles';
import DownloadFlashLogReport from '../../../components/reports/download-report';
import {
  headCells as reportsHeadCells,
  sortableAccessors as reportsHeadCellsAccessors,
} from '../../../components/reports/table/head-cells';
import { VirtualTableHeadCell } from '../../../components/virtualized-table/types';

const Reports = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();
  const flashLog = useSelector((state: AppState) => state.flashLog.flashLogs);
  const loading = useSelector((state: AppState) => state.flashLog.isLoading);
  const parameters: URLSearchParams = new URLSearchParams(location.search);
  const startTime = parameters.get(QueryParameterKeys.startTime) || undefined;
  const endTime = parameters.get(QueryParameterKeys.endTime) || undefined;
  const timeFrame = parameters.get(QueryParameterKeys.timeFrame) || '';
  const latest = parameters.get('latest') || '';
  const [columnVisibility, setColumnVisibility] = useState([]);
  const [columnOrder, setColumnOrder] = useState([]);
  const tableContainer: RefObject<HTMLDivElement> = useRef(null);

  const handleClickDownload = (row: any, setLoading: Function ) => {
    const {
      original: { reportDate },
    } = row;
    dispatch(getFlashLogExport(reportDate, setLoading));
  };

  const DownloadButton = ({ row }: any) => (
    <DownloadFlashLogReport row={row} callback={handleClickDownload} />
  );
  const downloadButton: VirtualTableHeadCell = {
    accessor: 'checkbox',
    width: 150,
    disableResizing: true,
    Header: '',
    component: DownloadButton,
  };

  const ReportsTableData = {
    title: 'FlashLog Reports',
    storageString: 'flashlog-reports-table',
    headerColumns: [...reportsHeadCells, downloadButton],
    sortableAccessors: reportsHeadCellsAccessors,
    data: flashLog,
    id: 'flashlog-reports',
    setColumnVisibility,
    columnVisibility,
    setColumnOrder,
    columnOrder,
    tableContainer,
    loading,
  };

  useEffect(() => {
    if (latest) {
      const newParameters = new URLSearchParams(parameters);
      newParameters.delete('latest');
      if (timeFrame !== 'custom') {
        newParameters.set('startTime', `${moment().subtract(timeFrame, `hours`).startOf("minute").toISOString()}`);
        newParameters.set('endTime', `${moment().endOf("minute").toISOString()}`);
      }
      history.replace({
        pathname: `/reports`,
        search: decodeURIComponent(newParameters.toString()),
      });
      return;
    }
    const input = {
      startTime,
      endTime,
    };

    dispatch(getFlashLogSummariesAction(input));
  }, [startTime, endTime, dispatch, history, latest, timeFrame]);
  return (
    <div className={classes.scrollBox}>
      <Grid container justifyContent="flex-end">
        <TimeRange blockFutureDates />
      </Grid>
      <div ref={tableContainer} className={classes.tableContainer}>
        <FlashLogTable {...ReportsTableData} />
      </div>
    </div>
  );
};

export default Reports;
